import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api-client";

export interface AdminVenue {
  id: string;
  slug: string;
  name: string;
  ownerId: string;
  subscriptionTier: string | null;
  status: string;
  stripeConnectedAccountId: string | null;
  activeCampaignCount: number;
  subscription: {
    stripeSubscriptionId: string;
    tier: string;
    status: string;
    currentPeriodEnd: string;
  } | null;
}

interface AdminVenuesResponse {
  success: boolean;
  data: {
    venues: AdminVenue[];
  };
}

export function useAdminVenues() {
  return useQuery({
    queryKey: ["admin-venues"],
    queryFn: async () => {
      const response = await apiGet<AdminVenuesResponse>("/admin/venues");
      return response.data.venues;
    },
    enabled: true,
  });
}
